<template>
    <div class="row justify-content-center">
        <div class="col-12" v-if="stats">
            <div class="card u-mb2">
                <div class="card-body">
                    <div class="row">
                        <div class="col-sm">
                            <h4>{{current.name}}</h4>
                        </div>
                        <div class="col-sm align-right">
                            <i class="fas fa-times u-clickable t-grey" v-on:click="stats = null"></i>
                        </div>
                    </div>
                    <div class="row">
                        <div class="col-12 align-center u-pt2 u-pb2" v-if="loading">
                            <i class="fas fa-circle-notch fa-spin fa-3x t-secondary"></i>
                        </div>
                        <div class="col-12" v-else>
                            <table class="table table-striped" v-if="hasForms">
                                <thead>
                                    <tr>
                                        <th>Form</th>
                                        <th>Responses</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    <tr v-for="f in stats.forms" v-bind:key="f.id">
                                        <td>{{f.title}}</td>
                                        <td>{{f.responses}}</td>
                                    </tr>
                                </tbody>
                            </table>
                            <div v-else class="alert alert-info">
                                {{current.name}} does not have any forms.
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div class="col-12 col-lg-7">
            <div class="card u-mb2">
                <div class="card-body">
                    <h3>Existing Form Customers</h3>
                    <table class="table table-striped">
                        <thead>
                            <tr>
                                <th>Name</th>
                                <th>Admin</th>
                                <th></th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr v-for="business in businesses" v-bind:key="business.id">
                                <td>{{business.name}}</td>
                                <td>
                                    <div v-if="business.user" class="t-small t-darkgrey">
                                        {{business.user.name}}<br>
                                        {{business.user.email}}
                                    </div>
                                </td>
                                <td class="align-right">
                                    <button class="btn btn-inverse btn-sm" v-on:click="showStats(business)">
                                        <i class="fas fa-chart-line"></i>
                                    </button>
                                    <a :href="'#/admin/' + business.id" class="btn btn-secondary btn-sm">
                                        <i class="fas fa-cog"></i>
                                    </a>
                                </td>
                            </tr>
                        </tbody>
                    </table>
                </div>
            </div>
        </div>
        <div class="col-12 col-lg-5">
            <div class="card u-mb2">
                <div class="card-body">
                    <h3>Add a new customer</h3>
                    <form v-on:submit.prevent="addBusiness">
                        <div class="form-group">
                            <label for="bid" class="col-form-label text-md-right">Rocket App ID (Optional)</label>
                            <input id="bid" type="tel" class="form-control" name="bname" v-model="model.id"  autofocus>
                        </div>
                        <div class="form-group">
                            <label for="bname" class="col-form-label text-md-right">Name</label>
                            <input id="bname" type="text" class="form-control" name="bname" v-model="model.name" required autocomplete="name" autofocus>
                        </div>
                        <div class="form-group">
                            <label for="email" class="col-form-label text-md-right">Admin User Email</label>
                            <input id="email" type="email" class="form-control" name="email" v-model="model.email" required autocomplete="email" autofocus>
                        </div>
                        <div class="form-group">
                            <label for="admin_name" class="col-form-label text-md-right">Admin User Name</label>
                            <input id="admin_name" type="text" class="form-control" name="admin_name" v-model="model.admin_name" required autocomplete="name" autofocus>
                        </div>
                        <div class="form-group u-mb1">
                            <button type="submit" class="btn btn-secondary">
                                Save
                            </button>
                        </div>
                    </form>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    mounted () {
        this.getBusinesses();
        this.$root.setUserId(0);
    },
    data () {
        return {
            model : {
                name : '',
                id : '',
                email : '',
                admin_name : ''
            },
            current : {},
            stats : null,
            businesses : []
        }
    },
    computed : {
        hasForms () {
            if (this.stats) {
                return this.stats.forms.length > 0;
            }
            return false;
        }
    },
    methods : {
        showStats (business) {
            // this.stats = null;
            this.loading = true;
            this.current = business;
            // let token = localStorage.getItem('builder.token');
            // this.axios.defaults.headers.common['Authorization'] = 'Bearer ' + token;
            this.axios.get(this.$root.env_url + '/api/business/' + business.id)
                .then(response => {
                    this.loading = false;
                    this.stats = response.data;
                })
                .catch(error => {
                    this.loading = false;
                    this.stats = null;
                    this.errorMsg('We could not load the stats for ' + business.name);
                });
        },
        getBusinesses () {
            this.$root.loading = true;
            // let token = localStorage.getItem('builder.token');
            // this.axios.defaults.headers.common['Authorization'] = 'Bearer ' + token;
            this.axios.get(this.$root.env_url + '/api/business')
                .then(response => {
                    this.businesses = response.data;
                    this.$root.loading = false;
                })
                .catch(error => {
                    this.errorMsg('Error! - We could not get the list of customers');
                    console.error('could not get businesses', error);
                    this.$root.loading = false;
                    if (error.response) {
                        let status = error.response.status;
                        if (status === 401) {
                            console.log('[NOT LOGGED INTO API] - logging out');
                            this.$root.logout();
                        }
                    }
                });
        },
        addBusiness () {
            this.$root.loading = true;
            // let token = localStorage.getItem('builder.token');
            // this.axios.defaults.headers.common['Authorization'] = 'Bearer ' + token;
            this.axios.post(this.$root.env_url + '/api/business', this.model)
                .then(response => {
                    this.successMsg('The customer was added');
                    this.getBusinesses();
                    this.$root.loading = false;
                    this.model = {
                        name : '',
                        id : '',
                        email : '',
                        admin_name : ''
                    };
                })
                .catch(error => {
                    this.errorMsg('Error! - We could not add the customer');
                    console.error('could not add business', error);
                    this.$root.loading = false;
                });
        }
    }
}
</script>
